import { Grid2 as Grid, Typography } from '@mui/material';
import { RevokedTokens, TokenGenerator, TokensList } from './components';

const SCIMTokenManagement = () => (
  <Grid container direction="column" spacing={2} sx={{ mb: 2 }}>
    <Typography variant="h4" gutterBottom>
      SCIM Token Management
    </Typography>
    <TokensList />
    <TokenGenerator />
    <RevokedTokens />
  </Grid>
);

export default SCIMTokenManagement;
